import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Home from "./pages/Home";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Students from "./pages/Students";
import Attendance from "./pages/Attendance";
import LessonPlans from "./pages/LessonPlans";
import Tasks from "./pages/Tasks";
import Exams from "./pages/Exams";
import Performance from "./pages/Performance";
import Communications from "./pages/Communications";
import WebsiteContent from "./pages/WebsiteContent";
import { isMaster } from "./components/SchoolSelect";

function Protected({ children, allow, masterOnly }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-zinc-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if ((allow && !allow.includes(user.role)) || (masterOnly && !isMaster(user)))
    return <Navigate to="/dashboard" replace />;
  return children;
}

const READERS = ["admin", "principal", "teacher", "parent"];

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={user ? <Navigate to="/dashboard" replace /> : <Login />} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/users" element={<Protected allow={["admin", "principal"]}><Users /></Protected>} />
        <Route path="/students" element={<Protected allow={READERS}><Students /></Protected>} />
        <Route path="/attendance" element={<Protected allow={["admin", "principal", "teacher"]}><Attendance /></Protected>} />
        <Route path="/lesson-plans" element={<Protected allow={["admin", "principal", "teacher"]}><LessonPlans /></Protected>} />
        <Route path="/tasks" element={<Tasks />} />
        <Route path="/exams" element={<Protected allow={READERS}><Exams /></Protected>} />
        <Route path="/performance" element={<Protected allow={READERS}><Performance /></Protected>} />
        <Route path="/communications" element={<Protected allow={READERS}><Communications /></Protected>} />
        <Route path="/website" element={<Protected allow={["admin"]} masterOnly><WebsiteContent /></Protected>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster richColors position="top-right" />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
